import type { IconData } from '@stacksjs/iconify-core'

export const designPencil: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M21.335 9.14h1.52v9.15h-1.52ZM12.2 3.05V1.52h-1.53v1.53H9.145v21.33h1.52V12.19h7.62v12.19h1.52V9.14h1.53V7.62h-1.53V3.05h-1.52V1.52h-1.52v1.53Zm6.09 1.52V6.1h-7.62V4.57Zm-7.625 19.81v3.05h1.53v-1.52h4.57v1.52h1.52v-3.05zm4.57 3.05h1.53v1.52h-1.53ZM12.195 0h4.57v1.52h-4.57Zm1.52 28.95h1.52V32h-1.52Zm-1.52-1.52h1.52v1.52h-1.52Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default designPencil
